import constants from "../../../../constants";
export const commonSelectedIntial = {
  selectedActivated: [],
  selectedActivatedAdmin: [],
  selectedDeactivated: [],
  selectedDeactivatedAdmin: [],
  selectedInvitationPending: [],
  selectedInvitationPendingWithouAdmin: [],
  selectedInvitationDeclined: [],
  selectedInvitationDeclinedWithouAdmin: [],
  selectedActivatedAndDeactivateAllAdmins: [],
  selectedActivatedAndDeactivate: [],
  selectedRemoved: [],
  selectedRemovedWithouAdmin: [],
};
export const setterCommonValues = (prev, curr) => {
  // staff {type}
  // 1=> activated
  // 2=> deactivated
  // 3=> invitation pending
  // 4=> invitation declined
  // 5=> removed
  switch (curr.type) {
    case constants.staffType.activated:
      if (curr.isAdmin) {
        prev.selectedActivatedAdmin.push(curr);
        prev.selectedActivatedAndDeactivateAllAdmins.push(curr);
      } else {
        prev.selectedActivated.push(curr);
        prev.selectedActivatedAndDeactivate.push(curr);
      }
      break;
    case constants.staffType.deactivated:
      if (curr.isAdmin) {
        prev.selectedDeactivatedAdmin.push(curr);
        prev.selectedActivatedAndDeactivateAllAdmins.push(curr);
      } else {
        prev.selectedDeactivated.push(curr);
        prev.selectedActivatedAndDeactivate.push(curr);
      }
      break;
    case constants.staffType.invitationPending:
      if (!curr.isAdmin) {
        prev.selectedInvitationPendingWithouAdmin.push(curr);
      }
      prev.selectedInvitationPending.push(curr);
      break;
    case constants.staffType.invitationDeclined:
      if (!curr.isAdmin) {
        prev.selectedInvitationDeclinedWithouAdmin.push(curr);
      }
      prev.selectedInvitationDeclined.push(curr);
      break;
    case constants.staffType.removed:
      if (!curr.isAdmin) {
        prev.selectedRemovedWithouAdmin.push(curr);
      }
      prev.selectedRemoved.push(curr);
      break;
    default:
      break;
  }
};
